module.exports = __webpack_public_path__ + "img/1494129400.12bacd44.jpg";